import React from 'react';
import Box from "@amzn/meridian/box";
import TopMetricsRow from '../TopMetricsRow/TopMetricsRowContainer';
import ProjectedBacklogCards from '../ProjectedBacklogCards/ProjectedBacklogCardsContainer';
import './index.scss';

const MetricsSection: React.FC = () => {
  return (
    <Box className="metrics-section">
      <TopMetricsRow />
      {/* 
      removed this code as part of - https://taskei.amazon.dev/tasks/UTR-REFLEX-308
       will need to uncomment later on, if not done by 21-03-26, please delete
       <ProjectedBacklogCards />
        */}
    </Box>
  );
};

export default MetricsSection;

import './index.scss';